module.exports = __webpack_public_path__ + "img/mastercard.4423593b.svg";